<div class="filter-pin-row">
  <!-- Control del filtro (si esta marcado tambien se ve en la barra) -->
  <div class="filter-pin-control">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>

  <!-- Columna del check -->
  <label class="filter-pin-check" [title]="'filter.visible-filters' | translate">
    <input
      type="checkbox"
      [checked]="checked"
      [attr.aria-label]="('filter.visible-filters' | translate) + ': ' + (label | translate)"
      (change)="onChange($event)"
    />
    <span class="filter-pin-box"><em class="fa fa-check"></em></span>
  </label>
</div>
